// Copyright 2021 The Casdoor Authors. All Rights Reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import { Button, Row, Col } from "antd";
import React from "react";
import i18next from "i18next";
import * as UserBackend from "../backend/UserBackend";
import * as Setting from "../Setting";

export const SendResetLink = ({
  disabled,
  username,
  application,
  onSent,
  onTimerEnd,
}) => {
  const [buttonLeftTime, setButtonLeftTime] = React.useState(0);
  const [buttonLoading, setButtonLoading] = React.useState(false);

  const getCodeResendTimeout = () => {
    // Use application's codeResendTimeout if available, otherwise default to 60 seconds
    return application && application.codeResendTimeout > 0
      ? application.codeResendTimeout
      : 60;
  };

  const handleCountDown = (leftTime = getCodeResendTimeout()) => {
    let leftTimeSecond = leftTime;
    setButtonLeftTime(leftTimeSecond);
    const countDown = () => {
      leftTimeSecond--;
      setButtonLeftTime(leftTimeSecond);
      if (leftTimeSecond === 0) {
        onTimerEnd?.();
        return;
      }
      setTimeout(countDown, 1000);
    };
    setTimeout(countDown, 1000);
  };

  const handleOk = () => {
    setButtonLoading(true);
    UserBackend.sendResetLinkByEcp(username)
      .then((res) => {
        console.log(res);
        if(res.ok) {
          handleCountDown(getCodeResendTimeout());
          onSent?.();
        } else {
          if (res.status === 404) {
            Setting.showMessage("error", i18next.t("general:Network unstable"));
          } else {
            res.json().then((data) => {
              Setting.showMessage("error", data?.message);
            });
          }
        }
      })
      .catch((error) => {
        Setting.showMessage("error", error?.message);
      })
      .finally(() => {
        setButtonLoading(false);
      });
  };

  return (
    <React.Fragment>
      <Row className="send-reset-link">
        <Col flex="auto">
          <Button
            className={buttonLeftTime > 0 ? "send-reset-link-button" : ""}
            block
            type="primary"
            htmlType="submit"
            disabled={disabled || buttonLeftTime > 0}
            loading={buttonLoading}
            onClick={() => handleOk()}
          >
            {buttonLoading
              ? ''
              : i18next.t("forget:Send Reset Link")}
          </Button>
        </Col>
        {buttonLeftTime > 0 && (
          <Col flex="50px">
            <div
              className="send-reset-link-time"
            >
              {`${buttonLeftTime} s`}
            </div>
          </Col>
        )}
      </Row>
    </React.Fragment>
  );
};
